import { INVITE_USER_DATA_REQUEST, INVITE_USER_DATA_FAILURE } from '../constants/invite_user_data.constants';

export const inviteUserDataRequest = () => ({
    type: INVITE_USER_DATA_REQUEST,
});

export const inviteUserDataFailure = error => ({
    type: INVITE_USER_DATA_FAILURE,
    error,
});



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/actions/invite_user_data.actions.js